import React from 'react';
import PropTypes from 'prop-types';
import CourseProp from '../propTypes/courseProp';
import AcademyEnrolledCourse from './AcademyEnrolledCourse';
import translate from '../../../commonComponents/translate';
import ServerSideCarousel from '../../../commonComponents/carousel/ServerSideCarousel';

function AcademyEnrolledCourses({ t, courses }) {
  return (
    <>
      <div className="academy-enrolled-subtitle">
        <h3 className="academy-enrolled-subtitle-text">
          {t('academy_myCourses')}
        </h3>
      </div>
      <ServerSideCarousel
        id="my-course-carousel"
        fetchUrl="/academy/enrolled"
        defaultFetchError="error_fetchCourses"
        items={courses}
      >
        {items =>
          items.map(course => (
            <AcademyEnrolledCourse key={course._id} course={course} />
          ))
        }
      </ServerSideCarousel>
    </>
  );
}

AcademyEnrolledCourses.propTypes = {
  t: PropTypes.func.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)).isRequired,
};

export default translate(AcademyEnrolledCourses);
